import { graphql, useFragment } from "react-relay";

import { useMeetingRecapAutoShareEnabled } from "../AutoShareRecapSettings";
import { AUTOMATION_CODE } from "./types";

import type { hooksAutomations_useAnySendAutomationsEnabled_stream$key } from "~/__generated__/hooksAutomations_useAnySendAutomationsEnabled_stream.graphql";

export function useAnySendAutomationsEnabled(
	streamKey: hooksAutomations_useAnySendAutomationsEnabled_stream$key,
): boolean {
	const stream = useFragment(
		graphql`
			fragment hooksAutomations_useAnySendAutomationsEnabled_stream on NoteStream {
				id
				automationConfigurations {
					id
					isActive
					automation {
						codeName
					}
				}
				meetingRecapAutoShareSource {
					__typename
					... on StreamMeetingRecapAutoShareSettings {
						id
						sendTo_S: sendTo
						setBy {
							id
							fullName
							firstName
						}
					}
					... on UserMeetingRecapAutoShareSettings {
						id
						sendTo_U: sendTo
						user {
							id
							fullName
							firstName
						}
					}
				}
			}
		`,
		streamKey,
	);

	const recapAutoShareEnabled = useMeetingRecapAutoShareEnabled(stream.meetingRecapAutoShareSource);

	const preMeetingReminderEnabled =
		stream.automationConfigurations?.some(
			config => config.isActive && config.automation.codeName === AUTOMATION_CODE.MEETING_REMINDER,
		) ?? false;

	const postMeetingRecapEnabled =
		stream.automationConfigurations?.some(
			config => config.isActive && config.automation.codeName === AUTOMATION_CODE.MEETING_RECAP,
		) ?? false;

	return recapAutoShareEnabled || preMeetingReminderEnabled || postMeetingRecapEnabled;
}
